import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=4c619b55&scoped=true"
import script from "./Global.vue?vue&type=script&lang=js"
export * from "./Global.vue?vue&type=script&lang=js"
import style0 from "./Global.vue?vue&type=style&index=0&id=4c619b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c619b55",
  null
  
)

export default component.exports